var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tech-icons"},_vm._l((this.tech),function(tech){return _c('span',{attrs:{"target":"_blank"}},[_c('b-tooltip',{attrs:{"multilined":"","animated":"","label":tech.tooltip}},[_c('b-icon',{staticClass:"icon-spacing",attrs:{"size":"is-large","icon":tech.icon,"pack":tech.pack}})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }